var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.wxPublicVisible,"footer":false,"width":"320px"},on:{"cancel":function($event){_vm.wxPublicVisible = false}}},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/jsz-wx-public.jpg"),"width":"100%"}}),_c('p',[_vm._v("请关注公众号“广州开放大学金沙洲分校”，关注成功后次日将开放学习资料下载权限！")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }